
define(
	'Eureka.MaxaPriceMatch.MaxaPriceMatch'
,   [
		'Eureka.MaxaPriceMatch.MaxaPriceMatch.View',
		'Eureka.MaxaPriceMatch.MaxaRequestReturn.View',
		'Eureka.MaxaPriceMatch.MaxaCustomerEnquiry.View'
	]
,   function (
		MaxaPriceMatchView,
		MaxaRequestReturnView,
		MaxaCustomerEnquiryView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var PageType = container.getComponent('PageType')

			PageType.registerPageType({
				name: 'MaxaAboutUs',
				routes: ['price-match'],
				view: MaxaPriceMatchView,
				defaultTemplate: {
					name: 'eureka_maxapricematch_maxapricematch.tpl',
					displayName: 'Request a Price Match'
				}
			})

			PageType.registerPageType({
				name: 'MaxaRequestReturn',
				routes: ['request-return'],
				view: MaxaRequestReturnView,
				defaultTemplate: {
					name: 'eureka_maxapricematch_maxarequestreturn.tpl',
					displayName: 'Request a Return'
				}
			})

			PageType.registerPageType({
				name: 'MaxaCustomerEnquiry',
				routes: ['customer-enquiry'],
				view: MaxaCustomerEnquiryView,
				defaultTemplate: {
					name: 'eureka_maxapricematch_maxacustomerenquiry.tpl',
					displayName: 'Customer Enquiry'
				}
			})
			
		}
	};
});
